import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { resolveRemoteUIMessage, useRemoteUICopy } from './copy.js';
import { useEffect, useRef, useState } from 'react';
export function AgentPlanningControl({ state, sessionStatus, planningSupported, onSetPlanning }) {
    const copy = useRemoteUICopy();
    const [target, setTarget] = useState();
    const [submitting, setSubmitting] = useState(false);
    const [failure, setFailure] = useState();
    const failureMessage = failure ? resolveRemoteUIMessage(copy, failure) : undefined;
    const inFlight = useRef(false);
    const agent = state.agent;
    const planning = agent?.runtimeInfo.planning;
    const supported = planningSupported ?? agent?.capabilities.planning === true;
    const pending = submitting || target !== undefined || planning?.requested !== undefined;
    const canChange = supported && planning !== undefined && sessionStatus === 'ready'
        && agent?.status === 'idle' && !agent.activeTurn && state.pendingInteractions.length === 0
        && !pending && onSetPlanning !== undefined;
    useEffect(() => {
        if (target !== undefined && planning?.active === target && planning.requested === undefined)
            setTarget(undefined);
    }, [planning?.active, planning?.requested, target]);
    async function change() {
        if (!canChange || inFlight.current || !onSetPlanning)
            return;
        inFlight.current = true;
        setSubmitting(true);
        setFailure(undefined);
        const requested = !planning.active;
        setTarget(requested);
        try {
            await onSetPlanning(requested);
        }
        catch (error) {
            setTarget(undefined);
            setFailure(error instanceof Error && error.message ? { text: error.message } : { key: 'planningChangeFailed' });
        }
        finally {
            inFlight.current = false;
            setSubmitting(false);
        }
    }
    return _jsxs("section", { className: "agent-planning-control", "aria-label": copy.sessionPlanningMode, children: [_jsxs("div", { children: [_jsx("span", { children: planning?.active ? copy.planning : planning ? copy.normalChat : copy.planningMode }), _jsx("button", { type: "button", role: "switch", "aria-label": copy.planningMode, "aria-checked": planning?.active === true, disabled: !canChange, onClick: () => void change(), children: planning?.active ? copy.on : copy.off })] }), _jsx("p", { className: "agent-composer-note", role: "status", children: !supported ? copy.planningUnsupported
                    : !planning ? copy.waitingPlanningState
                        : sessionStatus !== 'ready' ? copy.settingsDisconnected
                            : !onSetPlanning ? copy.planningReadOnly
                                : pending ? copy.waitingProviderConfirmation
                                    : !canChange ? copy.planningChangeUnavailable
                                        : copy.planningConfirmed }), failureMessage ? _jsx("p", { className: "agent-composer-note", role: "alert", children: failureMessage }) : null] });
}
//# sourceMappingURL=AgentPlanningControl.js.map